import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  orgNodesContainer: {
    width: '100%',
    '@media (min-width: 1024px)': {
      width: 'auto',
    },
  },
  orgNodesPopper: {
    zIndex: 10001,
    width: '96%',
    '@media (min-width: 640px)': {
      width: '511px',
    },
  },
  orgNodesPaper: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  orgButtonLabel: {
    gap: '4px',
    justifyContent: 'space-between',
  },
  orgButtonLabelLeft: {
    display: 'flex',
    gap: '8px',
  },
  orgButtonLabelRight: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  searchInput: {
    padding: '7px 12px',
    '& input': {
      padding: 0,
    },
  },
  orgNodesTreeRoot: {
    height: 'auto',
    flexGrow: 1,
    maxWidth: 500,
    border: `1px solid ${theme.evPalette.charcoal[500]}`,
    borderRadius: '4px',
    overflow: 'hidden',
    overflowY: 'auto',
    maxHeight: '300px',
    '@media (min-width: 640px)': {
      maxHeight: '500px',
    },
  },
  firstOrgNodeContent: {
    padding: '10px',
  },
  expandedChildrenContainer: {
    border: `1px solid ${theme.evPalette.charcoal[500]}`,
    borderRadius: '4px',
    padding: '8px 30px 8px 32px',
    backgroundColor: theme.evPalette.salt[100],
    '&.even': {
      backgroundColor: theme.evPalette.charcoal[100],
    },
    '&.first': {
      border: 'none',
      borderTop: `1px solid ${theme.evPalette.charcoal[500]}`,
      borderRadius: 0,
    },
  },
  treeItemGroup: {
    marginLeft: 0,
  },
  treeItemIcon: {
    width: '24px',
    height: '24px',
    '& svg': {
      fontSize: '24px',
      fill: theme.evPalette.charcoal[600],
    },
  },
  treeItemLabel: {
    padding: '9px',
    paddingLeft: '4px',
    display: 'flex',
    gap: '8px',
    '&>.myev-MuiCheckbox-root': {
      padding: 0,
    },
  },
  treeItemSelectIcon: {
    display: 'none',
  },
  treeItemSelectLabel: {
    display: 'flex',
    gap: '8px',
    padding: '9px',
    paddingLeft: '0px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    '&>.myev-MuiCheckbox-root': {
      padding: 0,
    },
  },
  labelText: {
    cursor: 'pointer',
  },
  selectAllLabelText: {
    cursor: 'pointer',
    color: theme.evPalette.ocean[700],
  },
  selectedOrgsCountChip: {
    height: '18px',
    color: theme.evPalette.charcoal[800],
    backgroundColor: theme.evPalette.charcoal[400],
    '& span': {
      padding: '0 8px',
      fontSize: '12px',
      fontWeight: 700,
      lineHeight: '14px',
    },
  },
}));
